import { useParams } from 'react-router';

import LoadingPage from '@/components/common/LoadingPage';
import SubPageHeader from '@/components/common/SubPageHeader';
import isEmpty from '@/lib/utils/isEmpty';

import RiskObjectGroups from './components/RiskObjectGroups';
import useRiskObject from './queries/hooks/useRiskObject';

export default function RiskObjectsDetail() {
  const { id } = useParams<{ id: string }>();

  const { data, isLoading } = useRiskObject(id ?? '', {
    enabled: !isEmpty(id),
  });

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <SubPageHeader>{data?.name ?? ''}</SubPageHeader>

      <main className="flex-1 overflow-y-auto">
        {isLoading && <LoadingPage />}

        {!isLoading && data && (
          <div className="p-2">
            <RiskObjectGroups riskObject={data} />
          </div>
        )}
      </main>
    </div>
  );
}
